export const colors = [
  '#D93911',
  '#F4A462',
  '#26A69A',
  '#274754',
  '#E76E50',
  '#68a860',
  '#3772ff',
  '#00695c',
  '#ffea00',
  '#3f51b5',
];
